import UserDropdown from "./UserInfoDropdown";
import BellIcon from "../../assets/icons/BellIcon";

export default function Header() {
  return (
    <>
      <header className="flex items-center justify-between p-4 w-full h-[80px] px-10 lg:mt-0 mt-[5px]">
        <h1 className="text-2xl font-bold text-white">Dashboard</h1>

        <div className="flex items-center space-x-4 user-info">
          <button
            className="p-2 rounded-lg"
            style={{ border: "1px solid #ffffff38" }}
          >
            <BellIcon />
          </button>
          <UserDropdown />
        </div>
      </header>
    </>
  );
}
